import { Skeleton } from 'antd';
import React, { useEffect, useState } from 'react'
import { useFetch } from '../../services/ApiService';

function PDFViewer({ url }) {
    const [loading, setLoading] = useState(true);
    const [pdfFile, setPdfFile] = useState(null);
    const { fetchApi } = useFetch();

    const getPdfFile = async (url) => {
        setLoading(true);
        const apiURL = '/api' + url.split('/api')[1]
        await fetchApi(apiURL, 'GET', {}, {}, {responseType: 'blob'}).then(res => {
            setPdfFile(URL.createObjectURL(res));
        })
        setLoading(false);

    }

    useEffect(() => {
        getPdfFile(url);
    }, [url])

    return (
        <Skeleton loading={loading}>
            {
                pdfFile !== null ?
                    <iframe src={pdfFile} frameborder="0" width="100%" height={800}></iframe> :
                    'Error while loading PDF'
            }
        </Skeleton>
    )
}

export default PDFViewer